import { render, staticRenderFns } from "./Business.vue?vue&type=template&id=7f42d2b6&scoped=true&"
import script from "./Business.vue?vue&type=script&lang=js&"
export * from "./Business.vue?vue&type=script&lang=js&"
import style0 from "./Business.vue?vue&type=style&index=0&id=7f42d2b6&lang=less&scoped=true&"
import style1 from "./Business.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f42d2b6",
  null
  
)

export default component.exports